import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { projectsData } from './projectsData';
import '../App.css';

const WorksProjectsPage = ({ nightMode, setNightMode }) => {
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState('index');

  const handleProjectClick = (slug, isLocked) => {
    if (isLocked) return; // Don't navigate if project is locked
    navigate(`/works/projects/${slug}`);
  };

  return (
    <div className={`works-projects-page ${nightMode ? 'night' : ''}`}>
      <div className="works-nav">
        <motion.button
          className="works-back"
          onClick={() => navigate('/works')}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          whileHover={{ x: -6 }}
        >
          <ArrowLeft size={18} />
          <span>Back</span>
        </motion.button>

        <motion.button
          className="works-theme"
          onClick={() => setNightMode(!nightMode)}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {nightMode ? '☀' : '🌙'}
        </motion.button>
      </div>

      <div className="projects-hero">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          SIDE PROJECTS
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          Experiments, collaborations, and personal briefs that test new rituals for luxury.
        </motion.p>
      </div>

      <div className="projects-toolbar">
        <div className="projects-count">{projectsData.length}</div>
        <div className="projects-toggle">
          <button
            className={viewMode === 'grid' ? 'active' : ''}
            onClick={() => setViewMode('grid')}
          >
            Grid
          </button>
          <button
            className={viewMode === 'index' ? 'active' : ''}
            onClick={() => setViewMode('index')}
          >
            Index
          </button>
        </div>
        <div className="projects-filter">All</div>
      </div>

      {viewMode === 'index' ? (
        <div className="projects-index">
          <div className="projects-index-header">
            <span>PROJECT</span>
            <span>FOCUS</span>
            <span>YEAR</span>
          </div>
          {projectsData.map((project, idx) => (
            <motion.button
              key={project.slug}
              className={`projects-index-row ${project.locked ? 'locked' : ''}`}
              onClick={() => handleProjectClick(project.slug, project.locked)}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: 0.05 * idx }}
            >
              <span className="row-title">{project.name}</span>
              <span className="row-desc">{project.description}</span>
              <span className="row-year">{project.year}</span>
              {project.locked && (
                <div className="locked-overlay">
                  <span>Will be unlocked soon</span>
                </div>
              )}
            </motion.button>
          ))}
        </div>
      ) : (
        <div className="projects-grid">
          {projectsData.map((project, idx) => (
            <motion.button
              key={project.slug}
              className={`projects-grid-card ${project.locked ? 'locked' : ''}`}
              onClick={() => handleProjectClick(project.slug, project.locked)}
              style={{ '--project-card-bg': project.image, '--project-card-accent': project.accent }}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.06 * idx }}
            >
              <span className="projects-grid-pill">{project.year}</span>
              <span className="projects-grid-name">{project.name}</span>
              {project.locked && (
                <div className="locked-overlay">
                  <span>Will be unlocked soon</span>
                </div>
              )}
            </motion.button>
          ))}
        </div>
      )}

      <Navigation activeSection="work" onNavigate={() => {}} nightMode={nightMode} />
    </div>
  );
};

export default WorksProjectsPage;
